export const replaceThemePrefix = (token: string) => token.replace('pt-', '');
